<template>
  <v-card>
    <v-footer padless fixed dark>
      <v-divider style=" line- "></v-divider>
      <v-card flat tile width="100%" style=" background-color: #ececec;" class=" text-center">
        <v-card-text  class="py-2">
          <v-btn class=" ml-0 mr-3" icon :to="`/i/${bussinessId}`">
            <v-icon color="grey" size="30px">mdi-home</v-icon>
          </v-btn>
          <v-btn class="ml-3 mr-11" icon :to="`/i/${bussinessId}/about`">
            <v-icon color="grey" size="30px">mdi-information</v-icon>
          </v-btn>
          <v-btn
              fab
              :color="bussiness.color_secondary ? bussiness.color_secondary : secondary"
              top
              right
              absolute
							:style="{left: '50%', transform:'translateX(-50%)'}"
							:href="`tel: ${this.bussiness.phone}`"
            >
            <v-icon color="white" size="30px">mdi-phone</v-icon>
          </v-btn>
          
			 <v-btn class="ml-11 mr-3" icon :to="`/i/${bussinessId}/share`">
            <v-icon color="grey" size="30px">mdi-share-variant</v-icon>
          </v-btn>

          <v-btn class="ml-3 mr-0" icon :to="`/i/${bussinessId}/splash`">
            <v-icon color="grey" size="30px">mdi-crop-free</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-footer>    
  </v-card>
</template>
<script>
import { mapState,mapGetters } from "vuex";
  export default {
		mounted(){
		},
		data: () => ({
		}),
		methods: {},
		computed: {
			...mapState(['bussinessId', 'bussiness']),
			secondary(){
				return this.$vuetify.theme.defaults.light.secondary
			}
		},
  }
</script>
